import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import BookingPage from "@/pages/BookingPage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import StagePage from "@/pages/StagePage";
import HomePage from "@/pages/HomePage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="neon-grid min-h-screen flex items-center justify-center">
        <p className="font-mono text-sm text-pink-400 uppercase tracking-[0.2em]">
          Caricamento…
        </p>
      </div>
    );
  }
  if (!user) return <Navigate to="/dj/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/prenota" element={<BookingPage />} />
            <Route path="/dj/login" element={<LoginPage />} />
            <Route
              path="/dj/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dj/stage"
              element={
                <ProtectedRoute>
                  <StagePage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#12121C",
              border: "1px solid #28283D",
              color: "#F8FAFC",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
